import * as actionTypes from '../actions/actionTypes';

const initialState = {
    faculties: [],
    loadingFaculties: false,
    educationForms: [],
    specialitiesByFaculty: [],
    loadingSpecialitiesByFaculty: false,
    coursesByFacultyAndSpeciality: [],
    loadingCoursesByFacultyAndSpeciality: false,
    disciplines: [],
    loadingDisciplines: false,
    rating: [],
    loadingRating: false,
    ratingDetails: null,
    loadingRatingDetails: false
};

const loadFaculties = (state) => {
    return {
        ...state,
        loadingFaculties: true
    }
}

const setFaculties = ( state, action ) => {
    let tmp = [...action.faculties]
    return {
        ...state,
        faculties: tmp,
        loadingFaculties: false
    }
};

const loadSpecialitiesByFaculty = (state) => {
    return {
        ...state,
        loadingSpecialitiesByFaculty: true
    }
}

const setSpecialitiesByFaculty = ( state, action ) => {
    let specialities = [...action.specialitiesByFaculty]
    let forms = [...action.educationForms]
    return {
        ...state,
        specialitiesByFaculty: specialities,
        educationForms: forms,
        loadingSpecialitiesByFaculty: false
    }
};

const loadCoursesByFacultyAndSpeciality = (state) => {
    return {
        ...state,
        loadingCoursesByFacultyAndSpeciality: true
    }
}

const setCoursesByFacultyAndSpeciality = ( state, action ) => {
    let courses = [...action.coursesByFacultyAndSpeciality]
    return {
        ...state,
        coursesByFacultyAndSpeciality: courses,
        loadingCoursesByFacultyAndSpeciality: false
    }
};

const loadDisciplines = (state) => {
    return {
        ...state,
        loadingDisciplines: true
    }
}

const setDisciplines = ( state, action ) => {
    let tmp = [...action.disciplines]
    return {
        ...state,
        disciplines: tmp,
        loadingDisciplines: false
    }
};

const loadRating = (state) => {
    return {
        ...state,
        loadingRating: true
    }
}

const setRating = ( state, action ) => {
    let tmp = [...action.rating]
    return {
        ...state,
        rating: tmp,
        loadingRating: false
    }
};

const loadRatingDetails = (state) => {
    return {
        ...state,
        loadingRatingDetails: true
    }
}

const setRatingDetails = ( state, action ) => {
    let tmp = {...action.ratingDetails}
    return {
        ...state,
        ratingDetails: tmp,
        loadingRatingDetails: false
    }
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_FACULTIES: return loadFaculties( state );
        case actionTypes.SET_FACULTIES: return setFaculties( state, action );
        case actionTypes.LOAD_SPECIALITIES_BY_FACULTY: return loadSpecialitiesByFaculty( state );
        case actionTypes.SET_SPECIALITIES_BY_FACULTY: return setSpecialitiesByFaculty( state, action );
        case actionTypes.LOAD_COURSES_BY_FACULTY_AND_SPECIALITY: return loadCoursesByFacultyAndSpeciality( state );
        case actionTypes.SET_COURSES_BY_FACULTY_AND_SPECIALITY: return setCoursesByFacultyAndSpeciality( state, action );
        case actionTypes.LOAD_DISCIPLINES: return loadDisciplines( state );
        case actionTypes.SET_DISCIPLINES: return setDisciplines( state, action );
        case actionTypes.LOAD_RATING: return loadRating( state );
        case actionTypes.SET_RATING: return setRating( state, action );
        case actionTypes.LOAD_RATING_DETAILS: return loadRatingDetails( state );
        case actionTypes.SET_RATING_DETAILS: return setRatingDetails( state, action );
        default: return state;
    }
};
export default reducer;